import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { bs_icon } from '@/assets/images';
import { BLUR_HASH } from '@/constants/layout';
import { formatDayTime } from '@/utils/dateFormats';
import { firebaseImage, ThumbSize } from '@/utils/firebaseImage';

interface TrendingCardProps {
  trendingTitle: string;
  trendingDate: string;
  trendingImage: string;
  onCardPress: () => void;
}

const TrendingCard = ({ trendingTitle, trendingDate, trendingImage, onCardPress }: TrendingCardProps) => {
  return (
    <TouchableOpacity onPress={onCardPress}>
      <View style={style.container}>
        <div className="aspect-square w-[90px] md:w-36 lg:w-40 xl:w-48">
          <Image
            source={trendingImage ? firebaseImage(trendingImage, ThumbSize.Small) : bs_icon}
            style={style.image}
            contentFit="cover"
            placeholder={{ blurhash: BLUR_HASH }}
          />
        </div>
        <View style={style.dataContainer}>
          <p className="sm:text-sm md:text-base lg:text-lg xl:text-xl">{trendingTitle}</p>
          <p className=" max-md:text-sm lg:text-base xl:text-lg opacity-60">{formatDayTime(trendingDate)}</p>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default TrendingCard;

const style = StyleSheet.create({
  container: {
    flexDirection: 'row'
  },

  image: {
    width: '100%',
    height: '100%',
    borderRadius: 10
  },

  dataContainer: {
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 5,
    color: 'black',
    justifyContent: 'space-between'
  },

  date: {
    fontSize: 12,
    opacity: 0.6
  }
});
